<template>
    <div class="context">
        <div class="header">
            <el-page-header @back="back" content="目标人员">
            </el-page-header>
        </div>

        <div class="form_box">
            <el-form :model="form" :rules="rules" ref="TargetForm" :disabled="look_disabled" label-width="100px">
                <div class="form_title">
                    <span>使用药物</span>
                    <span class="remark">（注：全部不选择为无限制该维度筛选条件）</span>
                </div>
                <div class="check_btn_box">
                    <div v-for="(item, index) in drugCodeList"
                         :key="index"
                         @click="checkOtherOne(item, 'drug_code_list')"
                         :class="item.checked ? 'active_btn':''"
                         class="check_btn">
                        {{item.name}}
                    </div>
                </div>
                <div class="form_title">
                    <span>癌种</span>
                    <span class="remark">（注：全部不选择为无限制该维度筛选条件）</span>
                </div>
                <div v-for="(item, index) in tumour_list"
                     class="check_item"
                     :key="index">
                    <div @click="checkAll(item)"
                         :class="item.checked?'active_btn':''"
                         class="check_title_btn">
                        {{item.tumour_type}}
                    </div>
                    <div class="check_btn_box">
                        <div v-for="(items, indexs) in item.tumour_list"
                             :key="indexs"
                             @click="checkOne(items, item)"
                             :class="items.checked?'active_btn':''"
                             class="check_btn">
                            {{items.name}}
                        </div>
                    </div>
                </div>

                <div class="form_title">
                    <span>用药阶段</span>
                    <span class="remark">（注：全部不选择为无限制该维度筛选条件）</span>
                </div>
                <div class="check_btn_box">
                    <div v-for="(item, index) in stage_list"
                         :key="index"
                         @click="checkOtherOne(item, 'medication_status')"
                         :class="item.checked?'active_btn':''"
                         class="check_btn">
                        {{item.name}}
                    </div>
                </div>
                <div class="date_">
                    <el-form-item label="距离复诊日期小于等于：" prop="less_medication_days" :inline-message="true">
                        <el-input
                            v-model="form.less_medication_days"
                            placeholder="请输入"
                            clearable
                            size="mini"
                            style="width:150px;"
                            >
                        </el-input>
                        天
                    </el-form-item>
                    <el-form-item label="超过复诊日期大于等于：" prop="over_medication_days" :inline-message="true">
                        <el-input
                            v-model="form.over_medication_days"
                            placeholder="请输入"
                            clearable
                            size="mini"
                            style="width:150px;"
                            >
                        </el-input>
                        天
                    </el-form-item>
                </div>

                <div class="form_title">
                    <span>基本信息</span>
                    <span class="remark">（注：全部不选择为无限制该维度筛选条件）</span>
                </div>
                <el-form-item label="身份:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in relation_list"
                             :key="index"
                             @click="checkOtherOne(item, 'relations')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="来源:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in type_list"
                             :key="index"
                             @click="checkOtherOne(item, 'reg_types')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="状态:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in status_list"
                             :key="index"
                             @click="checkOtherOne(item, 'patient_status')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="体验:">
                    <div class="check_btn_box">
                        <div v-for="(item, index) in experience_list"
                             :key="index"
                             @click="checkOtherOne(item, 'has_visited')"
                             :class="item.checked?'active_btn':''"
                             class="check_btn">
                            {{item.name}}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-if="!look_disabled" @click="submit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import {clone} from "@/global/utils";

    export default {
    name: "targetTypeView",
    data() {
        const checkNumber = (rule, value, callback) => {
            if(!value) {
                callback()
            }
            if (!isNaN(Number(value))) {
                callback()
            } else {
                callback(new Error('请输入正确的数值！'))
            }
        };
        return {
            drugCodeList: [],
            tumour_list: [],
            stage_list: [
                {name: '用药周期中', value: '1'},
                {name: '待提醒', value: '2'},
                {name: '已脱落', value: '3'},
            ],
            relation_list: [
                {name: '本人', value: '1'},
                {name: '家属', value: '2'},
                {name: '朋友', value: '3'},
            ],
            type_list: [
                {name: '助手码', value: '1'},
                {name: '自然渠道', value: '2'},
                {name: '医护码', value: '3'},
            ],
            status_list: [
                {name: '已注册', value: '1'},
                {name: '未审核', value: '2'},
                {name: '审核通过', value: '3'},
                {name: '审核未通过', value: '4'},
            ],
            experience_list: [
                {name: '已使用', value: 1},
                {name: '未使用', value: 2},
            ],

            form: {
                drug_code_list: [],
                tumour_ids: [],
                medication_status: [],
                less_medication_days: '',
                over_medication_days: '',
                relations: [],
                reg_types: [],
                patient_status: [],
                has_visited: '',
            },
            rules: {
                less_medication_days: [
                    { required: false, validator: checkNumber, trigger: 'change' }
                ],
                over_medication_days: [
                    { required: false, validator: checkNumber, trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        ...mapState("comInformationData", {
            tumour_type_dict: 'tumour_type_dict',
            drug_code_list: 'drug_code_list'
        }),
        look_disabled() {
            return this.look_type === 'look'
        }
    },
    props: [
        'user_form',
        'look_type',
    ],
    mounted() {
        this.drugCodeList = clone(this.drug_code_list);
        this.getTumour();
        this.form = clone(this.user_form);
        this.$nextTick(() => {
            this.refreshOther();
            this.refreshTumour(this.form.tumour_ids);
        })
    },
     methods: {
         back() {
             let params = null;
             this.$emit('changeSomeCode', params)
         },
         submit() {
            this.$refs['TargetForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        type: 'target_type',
                        form: this.form
                    };
                    this.$emit('changeSomeCode', params)
                } else {
                    return false;
                }
            });
         },

         getTumour() {
             this.tumour_list = clone(this.tumour_type_dict);
             this.tumour_list.map(v => {
                 v.checked = false;
                 v.tumour_list.map(e => e.checked = false)
             });
         },
         refreshTumour(ids) {
             if (ids) {
                 this.tumour_list.map(v => {
                     v.tumour_list.map(e => {
                         if (ids.indexOf(e.tumour_id) > -1 ||
                             ids.indexOf(String(e.tumour_id)) > -1 ) {
                             e.checked = true
                         }
                     })
                 });
                 this.tumour_list.map(v => {
                     let all = true;
                     v.tumour_list.map(e => {
                         if (e.checked === false) {
                             all = false
                         }
                     });
                     v.checked = all
                 })
             } else {
                 this.tumour_list.map(v => {
                     v.checked = false;
                     v.tumour_list.map(e => e.checked = false)
                 })
             }
             this.$forceUpdate(); // 数据修改后刷新页面
         },

         // 目标人员
         checkAll(item) {
             if (this.look_disabled) return; // 查看状态
             item.checked = !item.checked;
             item.tumour_list.map(v => v.checked = item.checked);
             this.getTumourIds()
         },
         checkOne(items, item) {
             if (this.look_disabled) return; // 查看状态 
             items.checked = !items.checked;
             let all = true;
             item.tumour_list.map(v => {
                 if (!v.checked) {
                     all = false
                 }
             });
             item.checked = all;
             this.getTumourIds()
         },
         getTumourIds() {
             this.form.tumour_ids = [];
             this.tumour_list.forEach(v => {
                 v.tumour_list.forEach(e => {
                     if (e.checked) {
                         this.form.tumour_ids.push(e.tumour_id)
                     }
                 })
             });
             this.$forceUpdate(); // 数据修改后刷新页面
             // console.log(this.form, 'form------605');
         },

         // 新增模块用药阶段等
         checkOtherOne(item, type) {
             if (this.look_disabled) return; // 查看状态
             if(type == 'has_visited'){
                this.experience_list.map(v => {
                    if(v.value != item.value){
                        v.checked = false
                    }
                })
             }
             item.checked = !item.checked;
             this.$forceUpdate(); // 数据修改后刷新页面
             this.getOtherIds(type)
         },
         getOtherIds(type) {
             this.form[type] = [];
             switch (type) {
                 case 'medication_status':
                     this.stage_list.forEach(v => {
                         if (v.checked) {
                             this.form[type].push(v.value)
                         }
                     });
                     break;
                 case 'relations':
                     this.relation_list.forEach(v => {
                         if (v.checked) {
                             this.form[type].push(v.value)
                         }
                     });
                     break;
                 case 'reg_types':
                     this.type_list.forEach(v => {
                         if (v.checked) {
                             this.form[type].push(v.value)
                         }
                     });
                     break;
                 case 'patient_status':
                     this.status_list.forEach(v => {
                         if (v.checked) {
                             this.form[type].push(v.value)
                         }
                     });
                 case 'drug_code_list':
                     this.drugCodeList.forEach(v => {
                         if (v.checked) {
                             this.form[type].push(v.drug_code)
                         }
                     });
                     break;
                 case 'has_visited':
                    this.form[type] = '';
                     this.experience_list.forEach(v => {
                         if (v.checked) {
                            this.form[type] = v.value;
                         }
                     });
                     break;
             }
         },

         refreshOther() {
             this.stage_list.forEach(v => {
                 if (this.form.medication_status.indexOf(v.value) > -1) {
                     v.checked = true
                 }
             });
             this.relation_list.forEach(v => {
                 if (this.form.relations.indexOf(v.value) > -1) {
                     v.checked = true
                 }
             });
             this.type_list.forEach(v => {
                 if (this.form.reg_types.indexOf(v.value) > -1) {
                     v.checked = true
                 }
             });
             this.status_list.forEach(v => {
                 if (this.form.patient_status.indexOf(v.value) > -1) {
                     v.checked = true
                 }
             });
             this.experience_list.forEach(v => {
                 if (this.form.has_visited == v.value) {
                     v.checked = true
                 }
             });
             this.drugCodeList.forEach(v => {
                 if (this.form.drug_code_list.indexOf(v.drug_code) > -1) {
                     v.checked = true
                 }
             });
             this.$forceUpdate(); // 数据修改后刷新页面
         }
    }
}
</script>

<style scoped lang="scss">
.context {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    overflow: hidden;
    .header {
        height: 45px;
    }
    .form_box {
        flex: 1;
        overflow-y: auto;
        padding: 5px;
        box-sizing: border-box;
        font-size: .875rem;
        .form_title {
            border-bottom: 1px solid #ccc;
            line-height: 40px;
            font-size: 1rem;
            padding: 0 10px;
            margin: 5px 0;
            color: #606266;
            .remark {
                padding-left: 20px;
                color: #909399;
                font-size: .75rem;
            }
        }
        .check_item {
            display: flex;
            white-space: nowrap;
            line-height: 18px;
            box-sizing: border-box;
            padding: 8px 0;
            .check_title_btn {
                text-align: center;
                margin: 5px 10px;
                padding: 5px;
                width: 60px;
                height: 18px;
                cursor: pointer;
                background: #F2F6FC;
                border: 1px solid #f2f6fc;
                border-radius: 2px;
            }
            .active_btn {
                border-color: #409EFF;
            }
        }
        .check_btn_box {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            line-height: 18px;
            .check_btn {
                margin: 5px;
                padding: 5px;
                height: 18px;
                cursor: pointer;
                border: 1px solid #fff;
                border-radius: 5px;
            }
            .active_btn {
                border-color: #409EFF;
            }
        }
    }
}
</style>
<style lang="scss">
.context .date_{
    .el-form-item{
        margin-bottom: 0;
        .el-form-item__label{
            padding-left: 10px;
            // width: auto !important;
            width: 176px !important;
        }
    }
}
</style>